// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

// Internal Dependencies
import Constants from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';

const debounceErrorHandler = _.debounce(() => {
  toast.error('The map model does not exists, please report to IT team.');
}, 200);

const withMallMapModel = (Component) => {
  const WithMallMapModel = (props) => {
    const { model } = props;
    const mapModel = _.find(Constants.MallNameMapping, (mallModel) => mallModel === model);

    if (IsEmpty(mapModel)) {
      debounceErrorHandler();
      return null;
    }

    return <Component fileName={mapModel} {...props} />;
  };

  WithMallMapModel.propTypes = {
    model: PropTypes.string.isRequired,
  };

  return WithMallMapModel;
};

export default withMallMapModel;
